import React from 'react';
import { useInView } from 'react-intersection-observer';

import "./Reveal.scss";

const buildStyle = delay => delay ? { "--reveal-delay": `${delay}ms` } : undefined;

export const Reveal = (props)=>{
    const { as:Tag = "div", children, className, delay = 0, ...rest } = props;
    const { ref, inView } = useInView({
        triggerOnce:true,
        threshold:.12,
        rootMargin:"0px 0px -8% 0px"
    });
    const classes = ["Reveal", inView && "Reveal--visible", className].filter(Boolean).join(" ");

    return (
        <Tag {...rest} ref={ref} className={classes} style={buildStyle(delay)}>
            {children}
        </Tag>
    )
}
